import React from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

function AuthLayout() {
  const navigate = useNavigate();

  const { uid } = useSelector((state: any) => state.authUser);

  if (uid) {
    navigate("/dashboard");
  }
  return <Outlet />;
}

export default AuthLayout;
